import { useLocation, Link } from "react-router-dom";
import { useEffect } from "react";
import { Home, Layout, LayoutDashboard, ListTodo, Wrench } from "lucide-react";
import { Button } from "@/components/ui/button";

const NotFound = () => {
  const location = useLocation();

  useEffect(() => {
    console.error("404 Error: User attempted to access non-existent route:", location.pathname);
  }, [location.pathname]);

  return (
    <div className="flex min-h-screen items-center justify-center bg-background p-6">
      <div className="text-center max-w-md space-y-6">
        <div className="space-y-2">
          <h1 className="text-5xl font-semibold text-foreground">404</h1>
          <p className="text-lg text-muted-foreground">Page not found</p>
        </div>
        
        <div className="p-3 rounded-lg bg-muted/50 border border-border">
          <p className="text-sm text-muted-foreground">
            Attempted path: <code className="text-foreground font-mono">{location.pathname}</code>
          </p>
        </div>
        
        <div className="flex flex-wrap gap-3 justify-center">
          <Button asChild variant="default">
            <Link to="/" className="gap-2">
              <Home className="h-4 w-4" />
              Home
            </Link>
          </Button>
          <Button asChild variant="outline">
            <Link to="/app" className="gap-2">
              <Layout className="h-4 w-4" />
              Open App
            </Link>
          </Button>
          <Button asChild variant="outline">
            <Link to="/app/dashboard" className="gap-2">
              <LayoutDashboard className="h-4 w-4" />
              Dashboard
            </Link>
          </Button>
          <Button asChild variant="outline">
            <Link to="/app/plan" className="gap-2">
              <ListTodo className="h-4 w-4" />
              Plan
            </Link>
          </Button>
          <Button asChild variant="outline">
            <Link to="/app/growth-instruments" className="gap-2">
              <Wrench className="h-4 w-4" />
              Growth Instruments
            </Link>
          </Button>
        </div>
      </div>
    </div>
  );
};

export default NotFound;
